/*
 * Copyright (c) 2024. Tooling Team
 */

import * as React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { Callback } from "../components/auth/callback";
import { Logout } from "../components/auth/logout";
import { LogoutCallback } from "../components/auth/logoutCallback";
import { PrivateRoute } from "./privateRoute";
import { SilentRenew } from "../components/auth/silentRenew";
import { HomePage } from "../pages/HomePage";
import EIPMapValueDefinition from "../pages/EIPMapValueDefinition";
import EIPCreateMap from "../pages/EIPCreateMap";
import { LoggedOut } from "../components/auth/loggedOut";
import { Forbidden } from "../components/auth/forbidden";
import { PATHS } from "../utils/constants";
import { MedDomainLatestBuilds } from "../pages/MedDomainLatestBuilds";
import { MedDomainDetails } from "../pages/MedDomainDetails";
import { MedDomainDiff } from "../pages/MedDomainDiff";
import { AdminManagement } from "../pages/AdminManagement";
import { ModernLatestBuilds } from "../pages/ModernLatestBuilds";
import { MedDomainEISDetails } from "../pages/MedDomainEISDetails";
import { LabDomainCodeEvidence } from "../pages/LabDomainCodeEvidence";

const MapManagementRedirect = () => <Redirect to="/" />;

export const Routes = (
  <Switch>
    <Route exact path="/callback" component={Callback} />
    <Route exact path="/logout" component={Logout} />
    <Route exact path="/logout/callback" component={LogoutCallback} />
    <Route exact path="/silentrenew" component={SilentRenew} />
    <Route exact path="/loggedout" component={LoggedOut} />
    <Route exact path={PATHS.forbidden.url} component={Forbidden} />
    <PrivateRoute exact path="/" component={HomePage} />
    <PrivateRoute
      exact
      path={PATHS.mapManagement.url}
      component={MapManagementRedirect}
    />
    <PrivateRoute
      exact
      path={PATHS.editMapMapValueDefinition.url}
      component={EIPMapValueDefinition}
    />
    <PrivateRoute exact path={PATHS.createMap.url} component={EIPCreateMap} />
    <PrivateRoute exact path={PATHS.admin.url} component={AdminManagement} />
    <PrivateRoute
      exact
      path={PATHS.medDomain.url}
      component={MedDomainLatestBuilds}
    />
    <PrivateRoute
      exact
      path={PATHS.medDomainDetails.url}
      component={MedDomainDetails}
    />
    <PrivateRoute
      exact
      path={PATHS.medDomainDiff.url}
      component={MedDomainDiff}
    />
    <PrivateRoute
      exact
      path={PATHS.medDomainEIS.url}
      component={ModernLatestBuilds}
    />
    <PrivateRoute
      exact
      path={PATHS.medDomainEISDetails.url}
      component={MedDomainEISDetails}
    />
    <PrivateRoute
      exact
      path={PATHS.labDomainCodeEvidence.url}
      component={LabDomainCodeEvidence}
    />
  </Switch>
);
